import { VideoTicket } from '../../../@types/types'

export const videoUploadTicketResponseToApp = ({ uploadUrl, validUntil, videoId }: VideoTicket): VideoTicket => ({
  uploadUrl,
  validUntil,
  videoId,
})
